export const bchParam = {
    subUnits: 100000000n,
};
//# sourceMappingURL=chain.js.map